export const XPThresholds = [
  2,
  4,
  6,
  8,
  10,
  12,
  15,
  18,
  22,
  26,
  30,
  40,
  50,
  60,
  80,
  100,
  130,
  160,
  190,
  200,
  240,
];

const XPMaxPerFloor = [10, 40, 80, 160, 240];

export const isMaxLevel = (level: number) => {
  return XPThresholds.length - 1 <= level;
};

export const hasLevelUp = (level: number, xp: number) => {
  return XPThresholds[level - 1] <= xp;
};

export const getXPProgress = (level: number, xp: number) => {
  const thresh = XPThresholds[level - 1];
  return `${xp}/${thresh}`;
};

export const canXPOnFloor = (xp: number, floor: number) => {
  return xp < (XPMaxPerFloor[floor - 1] || 0);
};
export const XPForDepth = (level: number, floor: number) => {
  return level + Math.floor(0.5 * (floor - 1) * level);
};
